import React, { useEffect, useState } from 'react'
import { compact, get } from 'lodash'
import { ConfirmBox, Dialog, Toaster } from '@ui'
import api from '@api'
import { useReload } from '@hooks/reloadContext'
import { handleError } from '@ui/canvas/utils'
import css from './confirmDialog.module.scss'
import { Button } from '@runeffective/evo-design-system'
import { Classes } from '@blueprintjs/core'
function ConfirmDialog({ floor }) {
  const reload = useReload()
  const confirmData = get(floor, 'confirm')
  const onConfirm = () => {
    //closing confirm popup
    close()
    if (get(confirmData, 'employee.isRemote') && get(confirmData, 'employee.noDeskNeeded')) {
      api.employee.toggleExcludeFromUnseated({
        ids: [confirmData.employee.id],
        isRemote: false,
        noDeskNeeded: false,
      })
    } else if (get(confirmData, 'employee.noDeskNeeded')) {
      api.employee.toggleExcludeFromUnseated({
        ids: [confirmData.employee.id],
        isRemote: confirmData.employee.isRemote,
        noDeskNeeded: false,
      })
    } else if (get(confirmData, 'employee.isRemote')) {
      api.employee.toggleExcludeFromUnseated({
        ids: [confirmData.employee.id],
        isRemote: false,
        noDeskNeeded: confirmData.employee.noDeskNeeded,
      })
    } else if (confirmData.nextToSpace.spaceAssignment.employee) {
      confirmData.nextToSpace.spaceAssignment.employee.neighborhoods = null
    }
    floor.updateSpaces?.(compact([confirmData.nextFromSpace, confirmData.nextToSpace]))
    api.space
      .seat({
        assignmentPlanId: floor.apId,
        toSpaceId: confirmData.space.id,
        employeeId: confirmData.employee.id,
        moveType: 'move',
      })
      .then(() => {
        floor.clearConfirm?.()
        reload.employeeCatalog()
        Toaster.success({
          message: `Moved ${confirmData.employee.name} to a ${confirmData.nextToSpace.code}`,
        })
      })
      .catch(handleError)
  }

  const [showConfirmBox, setShowConfirmBox] = useState(false)

  useEffect(() => {
    setShowConfirmBox(isShowConfirmBox(floor.confirm))
  }, [floor])

  const close = () => {
    setShowConfirmBox(false)
    floor.clearConfirm?.()
  }
  return (
    <Dialog
      isOpen={showConfirmBox}
      className={css.confirmPopup}
      onClose={close}
      isCloseButtonShown={true}
      title={<p className={css.title}>Confirm seating</p>}
      body={
        <div className={css.confirmMessage}>
          {get(confirmData, 'employee.noDeskNeeded') ? (
            <p>
              “No desk needed” will be removed from this employee’s profile. Do you want to update
              their profile and seat them?
            </p>
          ) : get(confirmData, 'employee.isRemote') ? (
            <p>
              “Remote” will be removed from this employee’s profile. Do you want to update their
              profile and seat them?
            </p>
          ) : get(confirmData, 'employee.neighborhoods') ? (
            <p>
              An employee is assigned to 1 or more neighborhoods. Would you like to remove an
              employee from their neighborhood(s) and seat them?
            </p>
          ) : (
            ''
          )}
        </div>
      }
      footer={
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <div className={css.actionButtons}>
              <Button
                aria-label="single icon button"
                onClick={close}
                size="default"
                layout="borderless"
              >
                Cancel
              </Button>
              <Button
                layout="primary"
                onClick={onConfirm}
                size="default"
                className={css.confirmButton}
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      }
    />
  )
}

const isShowConfirmBox = (confirmData) => {
  return (
    !!confirmData?.employee?.neighborhoods ||
    confirmData?.employee?.isRemote ||
    confirmData?.employee?.noDeskNeeded
  )
}
export default ConfirmDialog
